import { useCallback } from 'react';

import { useJobPostingContext } from '@/contexts/job-posting-context';

import { removeOpeningFromChannel } from './utils/channel-utils';

/**
 * Remove an opening from the posting.
 *
 * Removes the opening from the selected openings list, job details and all channels form states.
 */
export function useRemoveOpeningFromPosting(openingId: string) {
  const { hookForm, selectedOpeningIds, setSelectedOpeningIds } =
    useJobPostingContext();
  const { setValue, getValues } = hookForm;

  return useCallback(() => {
    setSelectedOpeningIds(selectedOpeningIds.filter(id => id !== openingId));

    const jobDetailsList = getValues('jobDetails');
    const updatedJobDetailsList = { ...jobDetailsList };
    delete updatedJobDetailsList[openingId];
    setValue('jobDetails', updatedJobDetailsList);

    const channels = getValues('channels') ?? {};
    const updatedChannels = { ...channels };

    Object.keys(channels).forEach(channelKey => {
      const result = removeOpeningFromChannel(channels[channelKey], openingId);
      if (result === null) {
        delete updatedChannels[channelKey];
      } else {
        updatedChannels[channelKey] = result;
      }
    });

    setValue('channels', updatedChannels);
  }, [
    setSelectedOpeningIds,
    selectedOpeningIds,
    openingId,
    getValues,
    setValue,
  ]);
}
